import React, {Fragment} from 'react';
import {Icons, Popup, Settings} from 'components';
import {toggle, includes, useNamedSelector, openPopup} from 'helpers';
import {store} from 'store';

export function SidebarPreferences(props) {
  return (
    <Fragment>
      <Icons.Settings title="Settings" onClick={openPopup(DisplaySettings, {props})} />
    </Fragment>
  );
}

function DisplaySettings({ shareStatus }) {
  const options = useNamedSelector('goals.weeklyObjectivesOptions');
  return (
    <Popup.Menu>
      <b className="nowrap">Display Options</b>
      <Popup.Menu.SubHeading>Objective Status</Popup.Menu.SubHeading>
      <Popup.Menu.Checkbox onClick={() => toggleStatus('In Progress')} checked={includes(options.status, 'In Progress')}>In Progress</Popup.Menu.Checkbox>
      <Popup.Menu.Checkbox onClick={() => toggleStatus('Completed')} checked={includes(options.status, 'Completed')}>Completed</Popup.Menu.Checkbox>
      { shareStatus &&
        <Settings.PopupShareStatus />
      }
    </Popup.Menu>
  );
}

function toggleStatus(status) {
  store.dispatch({
    type: 'UI_SETTING',
    module: 'weeklyObjectives',
    key: 'status',
    value: current => toggle(current, status, { separator: ', ', min: 1 }),
  });
}
